module.exports = __webpack_public_path__ + "img/centerl.80db8d41.png";